<ng-template #template>
  <div class="svc-page-navigator-item">
    <div role="button" class="svc-page-navigator-item-content" (click)="click($event)" [key2click]
      [class.svc-page-navigator-item--selected]="model.active"
      [class.svc-page-navigator-item--disabled]="anyModel.disabled">
      <div class="svc-page-navigator-item__dot" [attr.title]="model.title">
        <div class="svc-page-navigator-item__dot-content"></div>
      </div>

      <div class="svc-page-navigator-item__banner">
        <span class="svc-page-navigator-item__text">{{ model.title }}</span>
        <span class="svc-page-navigator-item__dot"><span class="svc-page-navigator-item__dot-content"></span></span>
      </div>
    </div>
  </div>
</ng-template>